import Vue from "vue";
import moment from "moment";
import axios from "axios";
import * as files from "../../../../fileUtils";
import { v4 as uuidv4 } from "uuid";
import { date } from "devexpress-dashboard/model/index.metadata";

export default {
  name: "Attachments",
  components: {
    AttachmentsTableComp: require("./manageAttachmentsTable.vue").default,
  },
  props: {
    appKey: {
      type: Number,
      required: true,
    },
    applicationId: {
      type: String,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
    enableAdditionalattachments: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      attachments: [],
      attachmentsMandatory: [],
      attachmentsOptional: [],
      attachmentsAdditional: [],
      isEdited: false,
      attachmentTypes: [],
      activeTab: "tab-mandatory",
    };
  },
  created() {
    this.$material.locale.dateFormat = "dd/MM/yyyy";
    this.getAttachments();
    this.formData = null;
    this.isEditedIndex = -1;
  },
  methods: {
    tabSelection(id) {},
    getAttachments() {
      //error trap
      if (this.appKey <= 0 && this.readOnly) {
        this.$alertMsg(this.$t("messages.FileDownloadError"));
        return;
      }

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      let addUrl = "appId=" + this.applicationId;

      if (this.readOnly) addUrl = addUrl + "&appKey=" + this.appKey;
      axios
        .get("/ActivityAttachment/GetAttachments?" + addUrl)
        .then((resp) => {
          //console.log("resp", resp);
          if (resp.status == 200) {
            this.attachmentTypes =
              resp.data.attachmentTypes != null
                ? resp.data.attachmentTypes
                : [];
            this.attachments = resp.data.attachments;
            this.attachments.forEach((p) => {
              p["editDisabled"] = true;
              if (!p.uuid || p.uuid.length === 0) p.uuid = uuidv4();
            });

            //create different list for different tabs
            this.attachmentsMandatory = this.attachments.filter(
              (p) => p.isSystem && p.mandatory
            );
            this.attachmentsOptional = this.attachments.filter(
              (p) => p.isSystem && !p.mandatory
            );
            this.attachmentsAdditional = this.attachments.filter(
              (p) => !p.isSystem
            );

            //decide selected tab
            if (
              this.attachmentsMandatory != null &&
              this.attachmentsMandatory.length > 0
            )
              this.activeTab = "tab-mandatory";
            else if (
              this.attachmentsOptional != null &&
              this.attachmentsOptional.length > 0
            )
              this.activeTab = "tab-optional";
            else this.activeTab = "tab-additional";
          }
        })
        .catch((err) => {
          this.$alertMsg(this.$t("messages.FileDownloadError"));
          console.log(err);
        })
        .finally(loader.hide());
    },
  },
};
